(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alz-image-zoom"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('alz-image-zoom')) {
  customElements.define('alz-image-zoom', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.viewport = this.querySelector('.alz-zoom__viewport');
      this.canvas = this.querySelector('[data-zoom-canvas]');
      this.loading = this.querySelector('[data-zoom-loading]');
      this.error = this.querySelector('[data-zoom-error]');
      const page = this.closest('[data-product-page]');
      if (!page || !this.dialog.showModal) return;
      page.addEventListener('click', event => {
        const trigger = event.target.closest('[data-product-zoom]');
        if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.open(trigger);
      }, options);
      this.querySelector('[data-zoom-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => this.trigger?.focus({ preventScroll: true }), options);
      this.observer = new ResizeObserver(() => {
        if (this.dialog.open && this.image?.naturalWidth) this.sizePhoto();
      });
      this.observer.observe(this.viewport);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.dialog?.open) this.dialog.close();
    }
    open(trigger) {
      this.trigger = trigger;
      this.loading.hidden = false;
      this.error.hidden = true;
      this.querySelector('[data-zoom-original]').href = trigger.href;
      const image = new Image();
      this.image = image;
      image.className = 'alz-zoom__photo';
      image.alt = trigger.querySelector('img')?.alt || '';
      image.draggable = false;
      image.decoding = 'async';
      image.hidden = true;
      image.onload = () => {
        if (this.image !== image || !this.dialog.open) return;
        this.loading.hidden = true;
        this.sizePhoto();
        image.hidden = false;
        this.viewport.scrollLeft = Math.max(0, (image.width - this.viewport.clientWidth) / 2);
        this.viewport.scrollTop = 0;
      };
      image.onerror = () => {
        if (this.image !== image) return;
        this.loading.hidden = true;
        this.error.hidden = false;
      };
      this.canvas.replaceChildren(image);
      if (!this.dialog.open) this.dialog.showModal();
      this.viewport.scrollTop = 0;
      image.src = trigger.href;
    }
    sizePhoto() {
      const image = this.image;
      if (!image?.naturalWidth || !this.viewport.clientWidth) return;
      const ratio = image.naturalWidth / image.naturalHeight;
      const detailWidth = this.viewport.clientHeight * 1.8 * ratio;
      const width = Math.round(this.viewport.clientWidth > 760 ? this.viewport.clientWidth : Math.max(this.viewport.clientWidth, Math.min(image.naturalWidth, detailWidth)));
      image.width = width;
      image.height = Math.round(width / ratio);
      image.style.width = width + 'px';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
